import client from "./client";

export const fetchPenaltyReport = async (params) => (await client.get("/reports/penalties", { params })).data;

export const exportPenaltyReport = async (kind, lang, filters) => {
  const res = await client.get("/reports/penalties/export", {
    params: { kind, lang, ...filters },
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const link = document.createElement("a");
  link.href = url;
  link.download = `penalties.${kind}`;
  link.click();
  window.URL.revokeObjectURL(url);
};
